module.exports = __webpack_public_path__ + "static/media/supplier-app-logo.e9c62546.png";